/* Craftybella cart helpers.
   1. The theme renders every cart line image as ?width=1 in BOTH src and
      data-src, then its lazy loader restores src from data-src - so a one-off
      rewrite of src alone gets reverted and the thumbnail stays a flat block.
      We rewrite both, drop data-widths/srcset and re-check on every mutation.
   2. A file-upload property (the customer's photo) prints as a raw CDN URL.
      Turn it into a short "View photo" link instead. */
(function () {
  'use strict';
  var W = 240;

  function big(u) {
    if (!u || u.indexOf('data:') === 0) return '';
    return /[?&]width=\d+/.test(u)
      ? u.replace(/([?&])width=\d+/, '$1width=' + W)
      : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
  }

  function fixImages() {
    document.querySelectorAll('.t4s-mini_cart__img').forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) return;
      var u = big(img.getAttribute('data-src') || img.getAttribute('src') || '');
      if (!u) return;
      if (img.getAttribute('src') !== u) img.setAttribute('src', u);
      if (img.getAttribute('data-src') !== u) img.setAttribute('data-src', u);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-widths');
      img.removeAttribute('data-sizes');
      img.setAttribute('decoding', 'async');
      box.style.backgroundImage = 'url("' + u + '")';
    });
  }

  function isImg(u) { return /\.(jpe?g|png|webp|gif|heic|avif)(\?|$)/i.test(u); }

  function fixProps() {
    document.querySelectorAll('.t4s-cart_meta_propertyList li').forEach(function (li) {
      var lab = li.querySelector('[class*="item-label"]');
      if (lab && /note|message|wish/i.test(lab.textContent)) li.classList.add('cb-note');
      if (li.getAttribute('data-cb-link') === '1') return;
      var m = li.innerHTML.match(/(https?:\/\/[^\s<"']+)/);
      if (!m) return;
      var url = m[1];
      li.setAttribute('data-cb-link', '1');
      li.classList.add('cb-file');
      li.innerHTML = li.innerHTML.replace(
        url,
        '<a class="cb-file__a" href="' + url + '" target="_blank" rel="noopener">' +
        (isImg(url) ? 'View photo' : 'View file') + '</a>'
      );
    });
  }

  /* On the personalisation products the visible Add to cart belongs to the
     tcustomizer app and is type="button", so the theme's own add-to-cart never
     runs and its counter is never told anything. Watch for any successful
     /cart request and re-read /cart.js, which is always authoritative. */
  /* Every cart read has to bypass the cache.

     /?sections=cart_data,mini_cart is the same URL on every request, so the
     browser (and any CDN in front of it) is free to answer an add-to-cart
     refresh with the copy it took at page load -- an empty cart. That is why
     the drawer kept opening empty and only came right after a manual refresh.
     A unique query string plus no-store makes every read a real one. */
  function fresh(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + '_cb=' + Date.now();
  }
  var NOCACHE = { Accept: 'application/json', 'Cache-Control': 'no-cache', Pragma: 'no-cache' };

  function syncCount() {
    fetch(fresh('/cart.js'), { headers: NOCACHE, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = String(c.item_count);
        document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = n; });
        document.documentElement.className = document.documentElement.className
          .replace(/t4s-cart-count-\d+/, 't4s-cart-count-' + n);
      })
      .catch(function () {});
  }

  /* The drawer markup comes from the theme's own section endpoint.

     It has to be asked from "/". Measured against the live store: asking the
     same thing from a product URL returns mini_cart as an empty string, so
     there is nothing to swap in and the drawer keeps whatever it had. Only the
     home page renders those two sections. The cache-buster above is what stops
     the answer coming from the browser's copy; the path is not the lever. */
  function sections() {
    var url = '/?sections=cart_data,mini_cart';
    var pv = (window.location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1];
    if (pv) url += '&preview_theme_id=' + pv;
    return fetch(fresh(url), { headers: NOCACHE, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function readCartData(cd) {
    var seg = String(cd || '').split('[t4s_split1]')[1] || '';
    var bits = seg.split('[t4s_split2]');
    var a = document.createElement('div'); a.innerHTML = bits[0] || '';
    var b = document.createElement('div'); b.innerHTML = bits[1] || '';
    return { count: (a.textContent || '').trim(), total: (b.textContent || '').trim() };
  }

  function paint(count, total) {
    document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = count; });
    if (total) document.querySelectorAll('[data-cart-tt-price]').forEach(function (e) { e.textContent = total; });
    document.documentElement.className = document.documentElement.className
      .replace(/t4s-cart-count-\d+/, 't4s-cart-count-' + count);
  }

  /* ---------- The drawer ----------
     This theme's cart drawer never opens, for anyone: not after an add, and
     not when the cart icon is clicked. Its trigger carries a mangled attribute
     (data-drawer-delay- , with a stray trailing hyphen) so the theme's own
     handler skips it, the drawer is never initialised, and it keeps the
     t4s-dn display:none class for the whole session. Its close button and
     overlay are dead for the same reason.

     Two things decide whether this drawer is visible, and both must change:
       t4s-dn           -> display:none, must come off
       aria-hidden      -> the CSS open state is .t4s-drawer[aria-hidden=false]
     So we drive it ourselves, using exactly the classes and attributes the
     theme uses. If the theme's own init is ever repaired, this still agrees
     with it rather than fighting it. */

  function drawerEl() { return document.querySelector('#t4s-mini_cart'); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('t4s-dn');
    /* Force layout between display:block and the transform change, so the
       slide actually animates. This was a requestAnimationFrame callback and
       that was a bug: rAF is throttled in a background tab, so the drawer
       could be left half-opened -- display:none removed but never revealed.
       Reading offsetHeight is synchronous and always runs. */
    void d.offsetHeight;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is--opend-drawer', 't4s-lock-scroll');
    var ov = document.querySelector('.t4s-close-overlay');
    if (ov) ov.classList.remove('t4s-op-0');
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
    var ov = document.querySelector('.t4s-close-overlay');
    if (ov) ov.classList.add('t4s-op-0');
    /* put display:none back only once it has slid out of view */
    setTimeout(function () {
      if (d.getAttribute('aria-hidden') === 'true') d.classList.add('t4s-dn');
    }, 450);
  }

  function drawerIsOpen() {
    var d = drawerEl();
    return !!d && d.getAttribute('aria-hidden') === 'false' && !d.classList.contains('t4s-dn');
  }

  /* Delegated, so it survives the drawer markup being replaced wholesale on
     every refresh. Bound once. Escape is deliberate: if anything above ever
     fails, the shopper is never trapped behind a drawer with a locked page. */
  var closeBound = false;
  function bindClose() {
    if (closeBound) return;
    closeBound = true;
    document.addEventListener('click', function (e) {
      if (!drawerIsOpen()) return;
      var d = drawerEl();
      if (e.target.closest('.t4s-close-overlay')) { closeDrawer(); return; }
      if (e.target.closest('#t4s-mini_cart .t4s-drawer__close, #t4s-mini_cart [data-drawer-close]')) {
        e.preventDefault(); closeDrawer(); return;
      }
      /* a click anywhere outside the panel closes it too */
      if (d && !d.contains(e.target) && !e.target.closest('[data-drawer-options]')) closeDrawer();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerIsOpen()) closeDrawer();
    });
  }

  /* The cart icon is dead for the same reason, so take it over as well. */
  function bindCartIcon() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.t4s-site-nav__cart a, [data-drawer-options]');
      if (!t) return;
      var opts = t.getAttribute('data-drawer-options') || '';
      var isCart = opts.indexOf('mini_cart') > -1 || !!t.closest('.t4s-site-nav__cart');
      if (!isCart) return;
      e.preventDefault();
      showDrawer();
    }, true);
  }

  /* Open first, fill second. Waiting for the network before showing anything
     made an add feel like it had hung for two or three seconds. */
  function showDrawer() { openDrawer(); refreshDrawer(false); }

  /* The photo-upload add has to be a real multipart POST, which reloads the
     page. return_to brings the shopper back to the product carrying this flag,
     our cue to open the drawer as though nothing had reloaded. */
  function openIfFlagged() {
    if (!/[?&]cb_added=1/.test(window.location.search)) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('cb_added');
      window.history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
    setTimeout(showDrawer, 400);
  }

  /* Put whatever the section endpoint gave us on screen, every time.

     This used to hold the new markup back until the count parsed out of
     cart_data matched /cart.js, and retry twice at 600ms before giving up. Two
     things went wrong with that. The wait was the 2-3 seconds between clicking
     Add to cart and the drawer appearing. And when the two never agreed -- a
     parse that comes back empty is enough -- it gave up and opened the drawer
     still holding the markup from page load, i.e. an empty cart, even though
     the item was in there. The shopper sees "nothing was added".

     So: swap first, then decide whether to go round again. /cart.js is the
     authority for the count, and the worst case is now a drawer showing the
     freshest markup we could get rather than the stalest. */
  function refreshDrawer(open, tries) {
    tries = tries || 0;
    return fetch(fresh('/cart.js'), { headers: NOCACHE, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return sections().then(function (j) {
          var host = document.querySelector('#t4s-mini_cart');
          var tmp = document.createElement('div');
          tmp.innerHTML = j.mini_cart || '';
          /* On the page, the drawer's outer element carries id="t4s-mini_cart".
             Asked for on its own, the same section comes back wrapped in
             id="shopify-section-mini_cart" instead -- the id we were looking for
             is never in the response. So the swap was skipped every time, in
             silence, and the drawer kept whatever markup it had at page load:
             an empty cart, until the shopper reloaded the page. Match the
             wrapper by any of the shapes it can arrive in, and fall back to
             whatever element actually holds the drawer body. */
          var freshEl = tmp.querySelector('#t4s-mini_cart') ||
                        tmp.querySelector('#shopify-section-mini_cart') ||
                        (tmp.querySelector('.t4s-drawer__wrap') || {}).parentElement ||
                        tmp.firstElementChild;
          if (host && freshEl && freshEl.children.length) host.innerHTML = freshEl.innerHTML;

          var info = readCartData(j.cart_data);
          paint(String(cart.item_count), info.total);
          pass();
          if (open) openDrawer();

          /* Asked too soon after an add, the section can still be rendering the
             cart as it was a moment ago. Only that case is worth another pass. */
          if (String(cart.item_count) !== info.count && tries < 2) {
            return new Promise(function (res) {
              setTimeout(function () { res(refreshDrawer(false, tries + 1)); }, 400);
            });
          }
        });
      })
      .catch(function () { syncCount(); });
  }

  var CART_RE = /\/cart\/(add|change|update)/;

  function watchCartCalls() {
    var of_ = window.fetch;
    if (typeof of_ === 'function' && !of_.__cb) {
      var wrapped = function (u) {
        var pr = of_.apply(this || window, arguments);
        try {
          var url = typeof u === 'string' ? u : (u && u.url) || '';
          if (CART_RE.test(url) && pr && pr.then) {
            pr.then(function (r) { if (r && r.ok) setTimeout(syncCount, 250); }).catch(function () {});
          }
        } catch (e) {}
        return pr;
      };
      wrapped.__cb = 1;
      window.fetch = wrapped;
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    if (!xs.__cb) {
      XMLHttpRequest.prototype.open = function (m, u) { this.__cbUrl = String(u || ''); return xo.apply(this, arguments); };
      var send = function () {
        var x = this;
        if (CART_RE.test(x.__cbUrl || '')) {
          x.addEventListener('load', function () { setTimeout(syncCount, 250); });
        }
        return xs.apply(this, arguments);
      };
      send.__cb = 1;
      XMLHttpRequest.prototype.send = send;
    }
  }

  function pass() { try { fixImages(); fixProps(); } catch (e) {} }

  function start() {
    watchCartCalls();
    document.addEventListener('cb:atc', showDrawer);
    bindClose();
    bindCartIcon();
    openIfFlagged();
    pass();
    [300, 900, 2000].forEach(function (d) { setTimeout(pass, d); });
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(pass, 80);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function () { setTimeout(pass, 250); }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
